import { FC, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNil } from 'lodash';
import { Chip, Grid } from '@material-ui/core';
import moment from 'moment-timezone';
import SelectElement from 'containers/CourtManagerAssignedExpertise/SelectElement';
import TextElement from 'containers/CourtManagerAssignedExpertise/TextElement';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import victimIcon from 'images/victim-icon.svg';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { COLORS } from 'constants/design';
import LetterDesignation from 'containers/CourtManagerAssignedExpertise/Documents/LetterDesignation';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { translate } from 'containers/services/translate';
import MissionDrawer from 'containers/TransactionManagerTimeLine/ContactVictim/MissionDrawer';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import messages from 'containers/TransactionManagerTimeLine/ContactVictim/messages';
import {
  SECOND_EXAMINATION_OPPOSING_LAWYER,
  SECOND_EXAMINATION_VICTIM,
} from 'containers/TransactionManagerTimeLine/ContactVictim/constants';
import LetterSecondExamination from 'containers/CourtManagerAssignedExpertise/Documents/LetterSecondExamination';
import { TransactionType } from 'typings/globalTypes';
import {
  isRealisedMission,
  isRejectedMission,
} from 'containers/CourtManagerAssignedExpertise/utils';
export interface MissionRecapProps {
  intl: IntlShape;
  missions: any;
  listings: any;
  claimId: number;
  claimNumber: string;
  corporealExperts: any;
  requestGetExpertUsers: Function;
  riskKey: string;
  transactionId: number;
  requestGetMissionTransaction: Function;
  victimId: number;
  requestUpdateMissionTransaction: Function;
  requestAssignedExpert: Function;
  isConsultation?: boolean;
  transactionInfo: TransactionType;
  lossDate: any;
  requestGetTransaction: Function;
}

const StyledGrid = {
  color: COLORS.TEXT_BLACK,
  fontWeight: 500,
  fontSize: '15px',
};
const StyledTitle = {
  padding: '12px 24px',
  color: COLORS.TEXT_BLACK,
  fontWeight: 400,
  fontSize: '1rem',
};
export const StyledSubTitle = {
  color: COLORS.LIGHT_GREY_TEXT,
  fontWeight: 400,
  fontSize: '15px',
  marginLeft: '25px',
};
const MissionRecap: FC<MissionRecapProps> = props => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [missionToUpdate, setMissionToUpdate] = useState({});
  const [openDrawerMission, setOpenDrawerMission] = useState(false);

  const handleOpenDrawerMission = (mission: any) => () => {
    setMissionToUpdate(mission);
    setOpenDrawerMission(true);
  };

  const handleToggleDrawer = () => {
    setOpenDrawerMission(false);
    setMissionToUpdate({} as any);
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div key={refreshKey}>
      {props.missions?.map((mission: any, i: number) => (
        <CustomAccordion
          title={translate({ ...messages.missionAccordionTitle }, props, {
            reference: mission.reference,
          })}
          textColor={COLORS.ACCORDION_TEXT_BLUE}
          bgColor={COLORS.ACCORDION_BG_BLUE}
          image={victimIcon}
          editButtonTitle={
            !props.isConsultation &&
            !isRejectedMission(mission) &&
            !isRealisedMission(mission)
              ? 'Modifier'
              : undefined
          }
          editButtonOnClick={
            !props.isConsultation &&
            !isRejectedMission(mission) &&
            !isRealisedMission(mission)
              ? handleOpenDrawerMission(mission)
              : undefined
          }
        >
          <Grid container direction="row" key={i}>
            <Grid item xs={12}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={4}>
                  <TextElement
                    label={translate(messages.expertiseNature, props)}
                    //@ts-ignore
                    value={getValueByCode(
                      mission?.type,
                      get(props.listings, 'expertise'),
                    )}
                    withoutPadding={true}
                  />
                </Grid>
                <Grid item xs={4}>
                  <SelectElement
                    label={translate(messages.expert, props)}
                    value={mission.assignedExperts.map((element: any) => ({
                      value: element.expertCode,
                      title: getValueByCodeSagis(
                        element.expertCode,
                        get(props.listings, 'intervenants'),
                      ),
                    }))}
                    multiple={true}
                    withoutPadding={true}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextElement
                    label={translate(messages.missionDate, props)}
                    value={moment(mission.missionDate).format('YYYY-MM-DD')}
                    withoutPadding={true}
                  />
                </Grid>
                {!isEmpty(get(mission, 'secondExamination', {})) && (
                  <>
                    <Grid item xs={12}>
                      <div
                        style={{
                          marginBottom: 10,
                          marginTop: 10,
                          fontSize: 16,
                        }}
                      >
                        {translate(messages.secondExaminationTitle, props)}
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <TextElement
                        label={translate(messages.typeTitle, props)}
                        value={
                          !isNil(
                            get(mission, 'secondExamination.victimId', null),
                          ) &&
                          isNil(
                            get(
                              mission,
                              'secondExamination.opposingLawyerId',
                              null,
                            ),
                          )
                            ? SECOND_EXAMINATION_VICTIM
                            : SECOND_EXAMINATION_OPPOSING_LAWYER
                        }
                        withoutPadding={true}
                      />
                    </Grid>
                    {!isNil(
                      get(mission, 'secondExamination.opposingLawyerId', null),
                    ) && (
                      <>
                        <Grid item xs={4}>
                          <TextElement
                            label={translate(messages.opposingLawyer, props)}
                            value={get(
                              mission,
                              'secondExamination.opposingLawyer.name',
                              null,
                            )}
                            withoutPadding={true}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextElement
                            label={translate(messages.opposingLawyer, props)}
                            value={get(
                              mission,
                              'secondExamination.opposingLawyer.email',
                              null,
                            )}
                            withoutPadding={true}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextElement
                            label={translate(
                              messages.opposingLawyerCity,
                              props,
                            )}
                            value={
                              getValueByCodeSagis(
                                get(
                                  mission,
                                  'secondExamination.opposingLawyer.city',
                                ),
                                get(props.listings, 'villes', []),
                              ) as any
                            }
                            withoutPadding={true}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextElement
                            label={translate(
                              messages.opposingLawyerAddress,
                              props,
                            )}
                            value={get(
                              mission,
                              'secondExamination.opposingLawyer.address',
                              null,
                            )}
                            withoutPadding={true}
                          />
                        </Grid>
                      </>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {mission.generateAssignementLetter && (
                <LetterDesignation
                  mission={{
                    ...mission,
                    assignedExpert: mission.assignedExperts,
                    missionNumber: mission.reference,
                    claimNumber: props.claimNumber,
                    lossDate: props.lossDate,
                  }}
                  listings={props.listings}
                  withoutPadding={true}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              {!isEmpty(get(mission, 'secondExamination', {})) && (
                <LetterSecondExamination
                  mission={{
                    ...mission,
                    assignedExpert: mission.assignedExperts,
                    missionNumber: mission.reference,
                    claimNumber: props.claimNumber,
                    lossDate: props.lossDate,
                  }}
                  listings={props.listings}
                />
              )}
            </Grid>
            {mission.assignedExperts && (
              <Grid item xs={12}>
                {mission.assignedExperts.map(
                  (el: { expertCode: string; reason: string }, i: number) => (
                    <>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{ padding: '15px 0px' }}
                        key={i}
                      >
                        <Grid item style={StyledGrid}>
                          {getValueByCodeSagis(
                            get(el, 'expertCode') as string,
                            get(props.listings, 'intervenants'),
                          ) + ' : '}
                        </Grid>
                        <Grid item xs={11}>
                          <Chip
                            style={{
                              backgroundColor: renderColor(
                                getValueByCode(
                                  get(el, 'status') as any,
                                  get(props.listings, 'missionStatus'),
                                ) as any,
                              ),
                              color: COLORS.WHITE,
                              fontWeight: 700,
                            }}
                            label={renderChipLabel(
                              getValueByCode(
                                get(el, 'status') as any,
                                get(props.listings, 'missionStatus'),
                              ) as any,
                            )}
                          />
                        </Grid>
                      </Grid>
                      {!isNil(get(el, 'reason', null)) && (
                        <>
                          <Grid style={StyledTitle}>
                            {translate(messages.rejectionReason, props)}
                          </Grid>
                          <Grid item style={StyledSubTitle}>
                            {get(el, 'reason', null)}
                          </Grid>
                        </>
                      )}
                    </>
                  ),
                )}
              </Grid>
            )}
          </Grid>
        </CustomAccordion>
      ))}
      {openDrawerMission && (
        <MissionDrawer
          open={openDrawerMission}
          handleToggleDrawer={handleToggleDrawer}
          listings={props.listings}
          requestAssignedExpert={props.requestAssignedExpert}
          claimId={props.claimId}
          missionToUpdate={{
            ...missionToUpdate,
            assignedExperts: get(missionToUpdate, 'assignedExperts', []),
            secondExamination: {
              id: get(missionToUpdate, 'secondExamination.id', null),
              type: !isNil(
                get(
                  missionToUpdate,
                  'secondExamination.opposingLawyerId',
                  null,
                ),
              )
                ? SECOND_EXAMINATION_OPPOSING_LAWYER
                : SECOND_EXAMINATION_VICTIM,
              opposingLawyer: {
                ...get(
                  missionToUpdate,
                  'secondExamination.opposingLawyer',
                  null,
                ),
              },
            },
          }}
          claimNumber={props.claimNumber}
          corporealExperts={props.corporealExperts}
          requestGetExpertUsers={props.requestGetExpertUsers}
          riskKey={props.riskKey}
          victimId={props.victimId}
          transactionId={props.transactionId}
          requestGetMissionTransaction={props.requestGetMissionTransaction}
          requestUpdateMissionTransaction={
            props.requestUpdateMissionTransaction
          }
          transactionInfo={props.transactionInfo}
        />
      )}
    </div>
  );
};

export default injectIntl(MissionRecap);
